<template>
  <div id="slider">
    <Slides v-if="slides.length > 0" :slides="slides"/>
  </div>
</template>

<script>
import axios from 'axios';
import Slides from './components/Slides.vue'

export default {
  name: 'Slider',
  components: {
    Slides
  },
  data: function () {
    return {
      slides: []
    }
  },
  methods: {
    async getImages(){
      const href = new URL(location.href)
      const segments = new URL(href).pathname.split('/');
      const last = segments.pop() || segments.pop(); // Handle potential trailing slash
      await axios.get(`/web/API/image/read.php?location_id=`+last)
      .then(response => {
          // JSON responses are automatically parsed.
          const reponse = response.data.records
          //for (const [key, value] of Object.entries(reponse)) {
          for (const value of Object.values(reponse)) {
            //this.slides.splice(`${key}`,0,`http://localhost/agencedelattre/web/locations/${value['nameImage']}`);
            this.slides.push(`/web/locations/${value['nameImage']}`)

          }
        })
    },
  },
  mounted () {
    this.getImages()
  }
}
</script>

<style>
#slider {
  font-family: "Lato", sans-serif;
  font-weight: 300;
  margin: 0 auto;
  max-width: 100%;
  padding: 30px;
}

.main {
  margin-bottom: 30px;
}

.thumbnails {
  margin: 0 -5px;
  width: calc(100% + 10px);
}

.agile__nav-button {
  background: transparent;
  border: none;
  color: #ccc;
  cursor: pointer;
  font-size: 24px;
  transition-duration: 0.3s;
}
.thumbnails .agile__nav-button {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}
.thumbnails .agile__nav-button--prev {
  left: -45px;
}
.thumbnails .agile__nav-button--next {
  right: -45px;
}
.agile__nav-button:hover {
  color: #888;
}
.agile__dot {
  margin: 0 10px;
}
.agile__dot button {
  background-color: #eee;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  display: block;
  height: 10px;
  font-size: 0;
  line-height: 0;
  margin: 0;
  padding: 0;
  transition-duration: 0.3s;
  width: 10px;
}
.agile__dot--current button, .agile__dot:hover button {
  background-color: #888;
}

.slide {
  align-items: center;
  box-sizing: border-box;
  color: #fff;
  display: flex;
  height: 450px;
  justify-content: center;
}
.slide--thumbniail {
  cursor: pointer;
  height: 100px;
  padding: 0 5px;
  transition: opacity 0.3s;
}
.slide--thumbniail:hover {
  opacity: 0.75;
}
.slide img {
  height: 100%;
  -o-object-fit: cover;
     object-fit: cover;
  -o-object-position: center;
     object-position: center;
  width: 100%;
}
</style>
